export * from './lib/ovsuite-icons.module';
export * from '../icons/index';
